import { Component, OnInit, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { ChartPart } from 'src/app/models/chart.model'
import { getChartAppleMusic, getLoading, getLoaded } from 'src/app/selectors/chart.selector'
import { Observable, Subscription } from 'rxjs'
import { MediaObserver, MediaChange } from '@angular/flex-layout'
import {
  getDataCollectByChartsAppleMusic,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-chart-item-apple-music',
    templateUrl: './chart-item-apple-music.component.html',
    styleUrls: ['./chart-item-apple-music.component.scss'],
    standalone: false
})
export class ChartItemAppleMusicComponent implements OnInit, OnDestroy {
  appleMusicInfo$: Observable<ChartPart[]>
  loading$: Observable<boolean>
  loaded$: Observable<boolean>
  allEmpty$: Observable<boolean>
  period$: Observable<any>
  private subscriptions: Subscription[] = []
  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(public media: MediaObserver, private store: Store<AppState>) {
    this.subscriptions.push(media.asObservable().subscribe(() => {}))
  }

  ngOnInit() {
    this.appleMusicInfo$ = this.store.select(getChartAppleMusic)
    this.loading$ = this.store.select(getLoading)
    this.loaded$ = this.store.select(getLoaded)

    this.dataCollections$ = this.store.select(getDataCollectByChartsAppleMusic)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }

  ngOnDestroy() {
    this.subscriptions.forEach(it => it.unsubscribe())
  }
}
